import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { GenericComponent, NoPartnerResponseText } from '../CustomerComponentsV2';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const getQnAV2 = (qna, transformedAppTrustData) => qna.map(_ref => {
  let {
    question,
    answer
  } = _ref;
  // --- Question ---
  const questionAsConfig = question(transformedAppTrustData);
  const Question = /*#__PURE__*/_jsx(_Fragment, {
    children: questionAsConfig.map((config, index) => /*#__PURE__*/_jsx(GenericComponent, _objectSpread({}, config), index))
  });

  // ---- Answer ----
  const answerAsConfig = answer(transformedAppTrustData);
  const Answer = /*#__PURE__*/_jsx(_Fragment, {
    children: answerAsConfig ? answerAsConfig.map((config, index) => /*#__PURE__*/_jsx(GenericComponent, _objectSpread({}, config), index)) : /*#__PURE__*/_jsx(NoPartnerResponseText, {
      byAtlassian: transformedAppTrustData.byAtlassian
    })
  });
  return {
    question: Question,
    answer: Answer
  };
});